import styled from 'styled-components';

export const GeneralWrapper = styled.div`
  padding-top: 64px;
  background: #FAF6F0;
  min-height: 100vh;

  p {
    padding: 0.25em 0;
  }
`
